export const GET_STORE = {
    // REDUCER_KEY: ({reducerName}) => reducerName
    ACCESSIBILITY: ({ accessibility }) => accessibility,
    ADMIN: ({ admin }) => admin,
    ASSESSMENT: ({ assessment }) => assessment,
    AUTH: ({ auth }) => auth,
    CLIENT: ({ client }) => client,
    CLIENTS: ({ clients }) => clients,
    DIRECTORY: ({ directory }) => directory,
    EMPLOYEES: ({ employees }) => employees,
    FAVOURITE: ({ favourite }) => favourite,
    FINANCE: ({ finance }) => finance,
    FINANCIAL: ({ financial }) => financial,
    GOALS: ({ goals }) => goals,
    HOME: ({ home }) => home,
    LISTS: ({ lists }) => lists,
    LOCALE: ({ locale }) => locale,
    MANAGERS: ({ managers }) => managers,
    PROFILE: ({ profile }) => profile,
    RATINGS: ({ ratings }) => ratings,
    RESOURCES: ({ resources }) => resources,
    SETTINGS: ({ settings }) => settings,
    SUMMARY: ({ summary }) => summary,
    SUPPLIER: ({ supplier }) => supplier,
    SUPPLIERS: ({ suppliers }) => suppliers,
    TICKETS: ({ tickets }) => tickets,
    TRANSACTIONS: ({ transactions }) => transactions,
    USERS: ({ users }) => users,
    VOUCHERS: ({ vouchers }) => vouchers,
    WELLBEING: ({ wellbeing }) => wellbeing,
}
